import { CrossTypeCellRenderer } from './CrossTypeCellRenderer';
import { DKPartNumberCellRenderer } from './DKPartNumberCellRenderer';
import { PackageTypeCellRenderer } from './PackageTypeCellRenderer';
import { PartNumberCellRenderer } from './PartNumberCellRenderer';
import { QuantityAvailableCellRenderer } from './QuantityAvailableCellRenderer';
import { ReverseCheckboxCellRenderer } from './ReverseCheckboxCellRenderer';
import { UnitPriceCellRenderer } from './UnitPriceCellRenderer';
import { PinNameCellRender } from './PinNameCellRender';
import { CustomColumnDataCellRenderer } from './CustomColumnDataCellRenderer';
import { UnitPriceTariffCellRenderer } from './UnitPriceTariffCellRender';

export const frameworkComponents = {
  PartNumberCellRenderer: PartNumberCellRenderer,
  crossTypeCellRenderer: CrossTypeCellRenderer,
  dkPartNumberCellRenderer: DKPartNumberCellRenderer,
  packageTypeCellRenderer: PackageTypeCellRenderer,
  unitPriceCellRenderer: UnitPriceCellRenderer,
  unitPriceTariffCellRenderer: UnitPriceTariffCellRenderer,
  quantityAvailableCellRenderer: QuantityAvailableCellRenderer,
  reverseCheckboxCellRenderer: ReverseCheckboxCellRenderer,
  pinNameCellRender: PinNameCellRender,
  customColumnDataCellRenderer: CustomColumnDataCellRenderer
};

export const frameworkStackViewComponents = {
  customColumnDataCellRenderer: CustomColumnDataCellRenderer
};
